/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::dc25f8b3db4176b6f65213eeb9bb43aa>>
 * @codegenId #tag-group
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen tag-group
 * @codegenParams { "props": {"children": true, "alignment": true } }
 * @codegenDependency ../../../../../../../design-system/tag-group/src/TagGroup/index.tsx <<SignedSource::25b12a649f3bf788a4cb061d0693d72f>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import PlatformTagGroup from '@atlaskit/tag-group';

type PlatformTagGroupProps = React.ComponentProps<typeof PlatformTagGroup>;

export type TagGroupProps = Pick<
  PlatformTagGroupProps,
  'children' | 'alignment'
>;

export const TagGroup = (props: Parameters<RenderFn>[0]) => {
  const {
    alignment,
  } = props.forgeDoc.props as TagGroupProps;
  return (
    <PlatformTagGroup
      children={props.forgeDoc.children.map(c => <React.Fragment key={c.key}>{props.render(c)}</React.Fragment>)}
      alignment={alignment}
    />
  );
};
/**
 * @codegenEnd
 */

